export enum MilestoneType {
    Site = 'Site', // Synonym for 'DataCollection'
    Form = 'Form'
};

export enum SiteMilestoneName {
    SiteOpening = 'Site Opening',
    SiteClosing = 'Site Closing'
};
